module.exports = __webpack_public_path__ + "static/media/close-white.474262bf.svg";